export default {
  breakpoint: 'xl',
  mobileHeight: '64px',
  alertHeight: '60px',
  alertMobileHeight: '50px',
};
